import React, { useState, useEffect } from "react";

import OportunidadeReadOnly from "./Form/ReadOnly";
import { createColumns } from "./Columns";
import Table from "../../../components/Table";
import Comentarios from "./Comentarios";
import { Spinner, Modal, Row, Col } from "reactstrap";
import ReactBSAlert from "react-bootstrap-sweetalert";
import api from "../../../services/api";
import EmpresaContext from "../../../contexts/Empresa";
import { useContext } from "react";

// export function goToPrint(id) {
//     props.history.push(`/admin/oportunidades/${new Number(id)}/print`)
// }

export default ({
  oportunidades,
  pageProperties,
  notify,
  loading,
  readOnly,
  isConversao,
  onOpenChatModal,
  onOpenCopilot,
  onCriarCard,
  onVerCards,
  onVerOportunidade,
  onOpenConverterModal,
  onOpenEncerrarModal,
  hasPipeline = false,
  ...props
}) => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [alert, setAlert] = useState(null);
  const [oportunidadeId, setOportunidadeId] = useState(undefined);

  const [comentariosOportunidade, setComentariosOportunidade] = useState(null);
  const [showModalComentarios, setShowModalComentarios] = useState(false);

  function goToEdit(id) {
    props.history.push(`/admin/oportunidades/${new Number(id)}/edit`);
  }
  //TODO: Copy this function to the new page.
  function goToPrint(id) {
    props.history.push(`/admin/oportunidades/${new Number(id)}/print`);
  }

  function handleShowOportunidade(id) {
    setOportunidadeId(id);
  }

  useEffect(() => {
    if (
      comentariosOportunidade &&
      comentariosOportunidade.id &&
      comentariosOportunidade.id > 0
    ) {
      setShowModalComentarios(true);
    }
  }, [comentariosOportunidade]);

  function handleCloseModalComentarios() {
    setShowModalComentarios(false);
    setComentariosOportunidade(null);
    props.reloadOportunidades();
  }

  function handleChangeStatusInList(op, newStatus) {
    if (newStatus === 'Aberta' && (op.data_encerramento || op.data_conversao)) {
      if (op.data_conversao) {
        setAlert(
          <ReactBSAlert
              warning
              title="Desfazer conversão?"
              onConfirm={() => executeDesfazerConversao(op)}
              onCancel={() => setAlert(null)}
              showCancel
              confirmBtnBsStyle="primary"
              confirmBtnText="Sim"
              cancelBtnBsStyle="link"
              cancelBtnText="Não"
              btnSize=""
          />
        );
      } else {
        setAlert(
            <ReactBSAlert
                warning
                title="Restaurar oportunidade?"
                onConfirm={() => executeRestaurar(op)}
                onCancel={() => setAlert(null)}
                showCancel
                confirmBtnBsStyle="primary"
                confirmBtnText="Sim"
                cancelBtnBsStyle="link"
                cancelBtnText="Não"
                btnSize=""
            />
        );
      }
    } else if (newStatus === 'Convertida' && !op.data_conversao) {
      if (onOpenConverterModal) onOpenConverterModal(op);
    } else if (newStatus === 'Perdida' && !op.data_encerramento) {
      if (onOpenEncerrarModal) onOpenEncerrarModal(op);
    }
  }

  async function executeRestaurar(op) {
    try {
      setAlert(null);
      await api.patch(`/common/empresas/${empresaSelecionada?.id}/oportunidades/${op.id}/restaurar-oportunidades`);
      if (notify) notify("success", "Oportunidade restaurada");
      if (props.reloadOportunidades) props.reloadOportunidades();
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível restaurar oportunidade");
    }
  }

  async function executeDesfazerConversao(op) {
    try {
      setAlert(null);
      await api.put(`/marketing/oportunidades/${op.id}/desfazer-conversao`, {
        user_id: empresaSelecionada?.id,
      });
      if (notify) notify("success", "Conversão desfeita com sucesso");
      if (props.reloadOportunidades) props.reloadOportunidades();
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível desfazer a conversão");
    }
  }

  return (
    <>
      {alert}
      {/*Modal dos Comentarios*/}
      <Modal
        size="lg"
        className="modal-dialog-centered"
        isOpen={showModalComentarios}
        toggle={() => handleCloseModalComentarios()}
      >
        <div className="modal-header" style={{ paddingBottom: 0 }}>
          <h5 className="modal-title" id="exampleModalLabel">
            Contactações
            <br />
            <small className="text-muted" title={`Código Oportunidade`}>
              {comentariosOportunidade ? "#" + comentariosOportunidade.id : ""}
            </small>
            <br />
            <small className="text-muted" title={`Nome do Cliente`}>
              {comentariosOportunidade
                ? comentariosOportunidade.cliente.nome
                : ""}
            </small>
          </h5>

          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleCloseModalComentarios}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body" style={{ paddingTop: 5 }}>
          <Row>
            <Col lg="12">
              {/* <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <h3>Comentários</h3>
                            </div> */}
              <Comentarios
                readOnly={readOnly}
                notify={notify}
                oportunidadeId={
                  comentariosOportunidade ? comentariosOportunidade.id : 0
                }
                oportunidadeIdToCrossSelling={null}
                tipoCrossSelling={null}
                onComentariosChanged={null}
              />
            </Col>
          </Row>
        </div>
      </Modal>

      <OportunidadeReadOnly
        show={oportunidadeId}
        oportunidadeId={oportunidadeId}
        onClose={() => setOportunidadeId(undefined)}
      />
      {loading && (!oportunidades || oportunidades.length === 0) ? (
        <div
          style={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
          }}
        >
          <Spinner color="primary" />
        </div>
      ) : (
        <Table
          classes="table-sm table-v-middle"
          condensed
          rowStyle={{ cursor: 'pointer' }}
          rowEvents={{
            onClick: (e, row) => {
              // Ignorar clique se for no menu de ações, botões ou links
              if (e.target.closest('[data-toggle="dropdown"]') || e.target.closest('.dropdown-menu') || e.target.closest('.btn') || e.target.closest('a')) {
                return;
              }
              onVerOportunidade && onVerOportunidade(row);
            }
          }}
          columns={createColumns({
            edit: readOnly ? handleShowOportunidade : goToEdit,
            // printThis: readOnly ? handleShowOportunidade : goToPrint
            printThis: goToPrint,
            isConversao,
            onOpenChatModal,
            onOpenCopilot,
            onCriarCard,
            onVerCards,
            onVerOportunidade,
            hasPipeline,
            setComentariosOportunidade: setComentariosOportunidade,
            onChangeStatusInList: handleChangeStatusInList,
          })}
          data={oportunidades}
          pageProperties={pageProperties}
          onTableChange={props.onTableChange}
          paginationLengths={[10, 25, 50, 100, 500]}
        />
      )}
    </>
  );
};
